<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="trash"
			class="svg-inline--fa fa-trash"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
		>
			<path
				class="light"
				fill="currentColor"
				d="M400.8 128c-8.284 0-15.2 6.324-15.94 14.58L356 465.4C355.4 473.6 348.4 480 340.1 480H107.9C99.63 480 92.63 473.6 92 465.4L63.16 142.6C62.42 134.3 55.51 128 47.23 128C37.83 128 30.45 136.1 31.29 145.4l28.84 322.8C62.38 493 83 512 107.9 512h232.3c24.88 0 45.5-19 47.75-43.75l28.84-322.8C417.5 136.1 410.2 128 400.8 128zM432 64h-96l-33.63-44.75C293.4 7.125 279.1 0 264 0h-80C168.9 0 154.6 7.125 145.6 19.25L112 64h-96C7.2 64 0 71.2 0 80s7.2 16 16 16h416c8.8 0 16-7.2 16-16S440.8 64 432 64zM152 64l19.25-25.62C174.3 34.38 179 32 184 32h80c5 0 9.75 2.375 12.75 6.375L296 64H152z"
			/>
			<path
				class="regular"
				fill="currentColor"
				d="M424 80C437.3 80 448 90.75 448 104C448 117.3 437.3 128 424 128H412.4L388.4 452.7C385.9 486.1 358.1 512 324.6 512H123.4C89.92 512 62.09 486.1 59.61 452.7L35.56 128H24C10.75 128 0 117.3 0 104C0 90.75 10.75 80 24 80H93.82L130.5 24.94C140.9 9.357 158.4 0 177.1 0H270.9C289.6 0 307.1 9.358 317.5 24.94L354.2 80H424zM177.1 48C174.5 48 171.1 49.34 170.5 51.56L151.5 80H296.5L277.5 51.56C276 49.34 273.5 48 270.9 48H177.1zM364.3 128H83.69L107.5 449.2C108.1 457.5 115.1 464 123.4 464H324.6C332.9 464 339.9 457.5 340.5 449.2L364.3 128z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'TrashCanIcon',
	components: { Icon },
	props,
}
</script>
